export const getFieldValue = <T>(field: { value?: T; default?: T }): T | undefined =>
  field.value !== undefined &&
  field.value !== null &&
  field.value !== '""' &&
  field.value !== ("null" as unknown as T)
    ? field.value
    : field.default;
